import { useEffect, useState } from "react";
import QRCode from "qrcode";
import { toRGBA } from "../parser/utils";
import { ALIGN_MAPPING } from "../constanst";

export default ({ data }) => {
  const {
    paddingTop,
    paddingBottom,
    paddingRight,
    paddingLeft,
    type,
    content,
    align,
    color,
  } = data;

  const [qrCodeUrl, setQrCodeUrl] = useState("");

  // 当 type 或 content 改变时，生成二维码
  useEffect(() => {
    if (type === "qrcode" && content) {
      QRCode.toDataURL(content)
        .then((url) => {
          setQrCodeUrl(url);
        })
        .catch((err) => {
          console.error("Failed to generate QR Code:", err);
        });
    } else {
      setQrCodeUrl(""); // 如果不是二维码类型或内容为空，清空二维码 URL
    }
  }, [type, content]);

  return (
    <div
      style={{
        paddingTop,
        paddingBottom,
        paddingRight,
        paddingLeft,
        display: "flex",
        justifyContent: ALIGN_MAPPING[align],
      }}
    >
      {type === "qrcode" && qrCodeUrl ? (
        <img
          src={qrCodeUrl}
          alt="QR Code"
          style={{ width: "100px", height: "100px" }}
        />
      ) : (
        <div
          style={{
            fontSize: "16px",
            color: color ? toRGBA(color) : "transparent", // 将 color 应用到文本上
          }}
        >
          {content}
        </div>
      )}
    </div>
  );
};
